import { render, staticRenderFns } from "./MoreThanTwoSegmentsMixOptions.vue?vue&type=template&id=8b0f13bc&lang=pug&"
import script from "./MoreThanTwoSegmentsMixOptions.vue?vue&type=script&lang=js&"
export * from "./MoreThanTwoSegmentsMixOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports